export default __webpack_public_path__ + "img/calendar2.9c119ba5.svg";